// @ts-nocheck
import styled from "styled-components";
import React from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Colors } from "constants/colors";

export const PromoWidgetContainer = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
}));

export const BannersContainer = styled.div<React.HTMLAttributes<HTMLDivElement>>(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.small,
    overflowX: "auto",
    overflowY: "hidden",
    paddingTop: theme.spacing.xLarge,
    paddingBottom: theme.spacing.small,
    scrollBehavior: "smooth",
    scrollSnapType: "x mandatory",
    "&::-webkit-scrollbar": {
        display: "none",
    },
}));

export const BannerImage = styled.img<React.ImgHTMLAttributes<HTMLImageElement>>(() => ({
    maxWidth: `${(240 / 360) * 100}%`,
    borderRadius: 8,
    objectFit: "cover" as const,
    scrollSnapAlign: "start",
}));

export const IndicatorsContainer = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.xxSmall,
}));

export const IndicatorDot = styled.div(({ theme }) => ({
    width: theme.spacing.xSmall,
    height: theme.spacing.xSmall,
    borderRadius: "50%",
    backgroundColor: theme.colors[theme.colorMode].text_Low_Emphasis,
}));

export const ActiveIndicator = styled(Text)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.slate75,
    paddingLeft: theme.spacing.xSmall,
    paddingRight: theme.spacing.xSmall,
    paddingTop: theme.spacing.xxxSmall,
    paddingBottom: theme.spacing.xxxSmall,
    borderRadius: 10,
    color: theme.colors[theme.colorMode].text_inverse_Highest_Emphasis,
}));
